<template>
  <div>
    <ValidationProvider v-slot="{ errors }" rules="required">
      <RadioButton
        :error-messages="showValidationErrors ? errors : []"
        @select="handleRadioChange"
        :selectedValue="answer"
        v-model="answer"
        :options="questionOptions"
        mixed
      />
    </ValidationProvider>
  </div>
</template>

<script>
import RadioButton from "@/components/common/RadioButton";
import { ValidationProvider } from "vee-validate";
import { map, first, size } from "lodash";
import {
  getAnswerIdByValue,
  getAnswerValueById
} from "@/views/profile/QuestionsAndAnswers/utils";

export default {
  props: {
    question: {
      type: Object,
      required: true
    },
    showValidationErrors: Boolean
  },
  components: {
    RadioButton,
    ValidationProvider
  },
  created() {
    const { answerData, options } = this.question;
    if (answerData && size(answerData.answers)) {
      this.answer = getAnswerIdByValue({
        questionOptions: options,
        answer: first(answerData.answers)
      });
    }
  },
  data() {
    return {
      answer: null
    };
  },
  computed: {
    questionOptions() {
      return map(this.question.options, option => ({
        label: option.option,
        value: option.id
      }));
    }
  },
  methods: {
    handleRadioChange(value) {
      this.answer = value;
      this.$emit("onChange", {
        question: {
          type: "booking-application-questions",
          id: this.question.id
        },
        answers: [
          getAnswerValueById({
            questionOptions: this.question.options,
            id: value
          })
        ]
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
